import React from 'react';
import Page from '../../components/Page/Page';
import seo from '../../constants/seo';

const DestinationPromotion = () => (
  <Page {...seo.destinationPromotion}>
    <h2 className="mt-0 pt-0">DESTINATION PROMOTION BODIES</h2>
    <p className="mb-1">Namaste,</p>
    <p>
      We understand that promoting a destination in the digital age can be daunting. How to
      reach out to trekkers? Which channels to use? How to create great content? How to be
      visible in Google Search? How much does it cost to create a mobile app?
    </p>
    <p>
      HoneyGuide can help you on all these fronts by:
      <ol>
        <li>
          Connecting you to people who can create high-quality videos, pictures, and written
          text.
        </li>
        <li>Managing the quality and format of content required for travelers.</li>
        <li>Advise you on increasing visibility in Google Search and Social Media.</li>
        <li>Help you reach out to a larger audience through HoneyGuide’s platform.</li>
        <li>Build Custom technology solutions if needed.</li>
      </ol>
    </p>
    <p>
      Some of the key features of working with HoneyGuide are:
      <ol>
        <li>
          Good Network with Exceptional Local Writers, Photographers, and Videographers.
          Check out our{' '}
          <a href="https://www.youtube.com/results?search_query=%23CelebrateSixSeasons">
            Celebrate Six Seasons Campaign
          </a>
          .
        </li>
        <li>
          Experience in Managing content on behalf of GiZ, TDS, and Manang Youth Society.{' '}
          Check out{' '}
          <a href="https://play.google.com/store/apps/details?id=com.tds.farwestnepal&hl=en">
            Far West Nepal
          </a>{' '}
          Mobile App and{' '}
          <a href="https://honeyguideapps.com/treks/annapurna-seven-passes-trek.e1b98d782329.everest-region">
            Annapurna Seven Passes Trek
          </a>
          .
        </li>
        <li>
          Feature your <a href="https://honeyguideapps.com/treks">Treks</a>,{' '}
          <a href="https://honeyguideapps.com/hotel-khangri.b9123c009dc0.namche-bazaar-lodges">
            Lodges
          </a>
          , Homestays, and <a href="https://honeyguideapps.com/guides">Local Guides</a> in
          HoneyGuide
        </li>
        <li>
          Feature your Treks in HoneyGuide’s Trekking in Nepal Mobile App.{' '}
          <a href="https://play.google.com/store/apps/details?id=com.trekkinginnepal.app&hl=en">
            Android
          </a>{' '}
          and{' '}
          <a href="https://itunes.apple.com/la/app/trekking-in-nepal/id1112263577?mt=8">
            iOS
          </a>
        </li>
      </ol>
    </p>
    <p>
      So if you wish to take your destination promotion initiative to the next level, drop
      us a line, and we will get back to you within 2 business days.
    </p>
    <p>
      If you have any questions, please contact: <br />
      Ashish Shrestha<br />
      +977-9841370673 <br />
      <a href="mailto:honeyhunter@honeyguideapps.com">honeyhunter@honeyguideapps.com</a>
    </p>
    <iframe
      src="https://docs.google.com/forms/d/e/1FAIpQLSef3qfv5Dkvot0XDqpdjut1JI1AWFs53BYvd-rd6YFQd0fQkQ/viewform?embedded=true"
      width="100%"
      height="948"
      frameBorder="0"
      marginHeight="0"
      marginWidth="0"
      title="Destination Promotion"
    >
      Loading...
    </iframe>
    <p>
      <strong>About HoneyGuide</strong> <br />
      HoneyGuide is a technology company that helps men and mountains meet more often. While
      we go about it, we are constantly guided by our belief that:
      <ol>
        <li>
          Providing Trekkers with No-strings attached and Accurate Information will make our
          mountains safer and help more people enjoy the thrills of a rarefied atmosphere.
        </li>
        <li>A Trekker should have the power to run a trek the way she sees fit easily.</li>
        <li>
          Connecting Local Service Providers with Trekkers will lead to a more equitable
          distribution of tourism dividends and increase service levels faster.
        </li>
      </ol>
    </p>
  </Page>
);

export default DestinationPromotion;



// WEBPACK FOOTER //
// ./src/screens/Partners/DestinationPromotion.jsx